var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.3 708.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            clip-path: url(#clippath);\n            }\n\n            .cls-2 {\n            stroke-width: 0px;\n            }\n\n            .cls-2, .cls-3 {\n            fill: none;\n            }\n\n            .cls-3 {\n            stroke: #4894a8;\n            stroke-miterlimit: 10;\n            }\n\n            .cls-4 {\n            opacity: .3;\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 521.3,
    height: 708.08
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275-2",
    className: "cls-3",
    d: "m9.9.54C6.54,3.54,3.35,6.72.33,10.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276-2",
    className: "cls-3",
    d: "m.33,34.58C20.34,12.6,33.44,10.92,49.5.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277-2",
    className: "cls-3",
    d: "m.33,59.08C30.03,26.47,44.5,38.57,76.05.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278-2",
    className: "cls-3",
    d: "m.33,83.59c30.02-32.96,44.48-20.24,76.75-59.79,6.02-7.24,11.34-15.02,15.9-23.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279-2",
    className: "cls-3",
    d: "m.33,108.1c30.02-32.96,44.48-20.24,76.75-59.79C93.11,28.68,98.62,14.43,103.39.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280-2",
    className: "cls-3",
    d: "m.33,132.61c30.02-32.96,44.48-20.24,76.75-59.79C102.31,41.9,101.48,24.33,112.76.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281-2",
    className: "cls-3",
    d: "m.33,157.12c30.02-32.96,44.48-20.24,76.75-59.79C110.14,56.82,98.45,39.22,127.91.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282-2",
    className: "cls-3",
    d: "m.33,181.63c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76,5.67-7.14,12.05-13.68,19.04-19.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283-2",
    className: "cls-3",
    d: "m.33,206.14c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76C157.26,13.42,171.62,14.71,191.26.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284-2",
    className: "cls-3",
    d: "m.33,230.65c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76,34.44-42.22,48.59-24.88,83.04-67.09.4-.49.79-.98,1.18-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285-2",
    className: "cls-3",
    d: "m.33,255.15c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76,34.44-42.22,48.59-24.88,83.04-67.09,6.68-8.02,12.49-16.72,17.33-25.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286-2",
    className: "cls-3",
    d: "m.33,279.66c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76,34.44-42.22,48.59-24.88,83.04-67.09,17.06-20.92,22.21-35.72,27.23-50.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287-2",
    className: "cls-3",
    d: "m.33,304.17c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76,34.44-42.22,48.59-24.88,83.04-67.09,26.18-32.09,24.29-49.8,37-74.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288-2",
    className: "cls-3",
    d: "m.33,328.68c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76,34.44-42.22,48.59-24.88,83.04-67.09,33.82-41.46,20.79-58.91,52.94-99.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289-2",
    className: "cls-3",
    d: "m.33,353.19c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09c34.45-42.22,20.3-59.54,54.75-101.75,8.55-10.48,15.86-17.29,22.53-22.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290-2",
    className: "cls-3",
    d: "m.33,377.7c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09c34.45-42.22,20.3-59.54,54.75-101.75,26.94-33.03,41.46-29.61,63-46.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291-2",
    className: "cls-3",
    d: "m.33,402.21c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09c34.45-42.22,20.3-59.54,54.75-101.75s48.59-24.89,83.03-67.09c1.16-1.42,2.26-2.82,3.31-4.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292-2",
    className: "cls-3",
    d: "m.33,426.72c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c7.35-8.78,13.62-18.41,18.68-28.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293-2",
    className: "cls-3",
    d: "m.33,451.23c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c18.12-22.2,22.8-37.52,28.18-53.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294-2",
    className: "cls-3",
    d: "m.33,475.73c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c27.12-33.23,24.13-51.04,38.43-77.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295-2",
    className: "cls-3",
    d: "m.33,500.24c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76l.37-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296-2",
    className: "cls-3",
    d: "m.33,524.75c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76,10.22-12.52,18.65-19.8,26.35-24.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297-2",
    className: "cls-3",
    d: "m.33,549.26c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76,28.27-34.66,42.87-29.19,66.25-49.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298-2",
    className: "cls-3",
    d: "m.33,573.77c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.1c1.93-2.37,3.71-4.66,5.34-6.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299-2",
    className: "cls-3",
    d: "m.33,598.28c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.1c9.89-12.12,15.77-22.19,19.95-31.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300-2",
    className: "cls-3",
    d: "m.33,622.79c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.1c19.15-23.47,23.28-39.25,29.1-55.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301-2",
    className: "cls-3",
    d: "m.33,647.3c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.1c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302-2",
    className: "cls-3",
    d: "m.33,671.8c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.1c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303-2",
    className: "cls-3",
    d: "m.33,696.31c30.02-32.96,44.48-20.24,76.75-59.79,34.45-42.22,20.31-59.54,54.75-101.76s48.59-24.88,83.04-67.09,20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.1c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304-2",
    className: "cls-3",
    d: "m14.4,707.52c21.36-16.86,35.87-13.64,62.68-46.49,34.45-42.22,20.31-59.54,54.75-101.76,34.44-42.22,48.59-24.88,83.04-67.09s20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.1c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305-2",
    className: "cls-3",
    d: "m54.91,707.52c6.57-4.94,13.77-11.69,22.17-21.98,34.45-42.22,20.31-59.54,54.75-101.76,34.44-42.22,48.59-24.88,83.04-67.09s20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306-2",
    className: "cls-3",
    d: "m79.1,707.52c31.88-40.4,18.99-57.88,52.73-99.24,34.45-42.22,48.59-24.88,83.04-67.09s20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307-2",
    className: "cls-3",
    d: "m94.96,707.52c12.57-25.05,10.78-42.76,36.87-74.73,34.45-42.22,48.59-24.88,83.04-67.09s20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308-2",
    className: "cls-3",
    d: "m104.69,707.52c4.99-14.67,10.17-29.42,27.14-50.22,34.45-42.22,48.59-24.88,83.04-67.09s20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309-2",
    className: "cls-3",
    d: "m114.63,707.52c4.82-9.15,10.58-17.77,17.2-25.71,34.45-42.22,48.59-24.88,83.04-67.09,34.45-42.22,20.3-59.54,54.75-101.74s48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310-2",
    className: "cls-3",
    d: "m130.86,707.52c.32-.39.64-.8.97-1.2,34.45-42.22,48.59-24.88,83.04-67.09s20.3-59.54,54.75-101.75,48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311-2",
    className: "cls-3",
    d: "m155.79,707.52c19.46-13.9,33.8-12.81,59.08-43.78,34.44-42.22,20.3-59.54,54.75-101.75s48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312-2",
    className: "cls-3",
    d: "m196.14,707.52c6.87-5.79,13.14-12.25,18.73-19.28,34.44-42.22,20.3-59.54,54.75-101.75s48.59-24.89,83.03-67.09c34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313-2",
    className: "cls-3",
    d: "m218.98,707.52c29.22-38.49,17.65-56.1,50.64-96.52,34.44-42.22,48.59-24.89,83.03-67.09,34.44-42.2,20.31-59.54,54.76-101.76s48.59-24.89,83.04-67.11c20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314-2",
    className: "cls-3",
    d: "m234.05,707.52c11.17-23.65,10.42-41.2,35.57-72.01,34.44-42.22,48.59-24.89,83.03-67.09,34.44-42.2,20.31-59.54,54.76-101.76,34.45-42.22,48.59-24.89,83.04-67.1,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315-2",
    className: "cls-3",
    d: "m243.4,707.52c4.75-13.8,10.29-27.99,26.22-47.5,34.44-42.22,48.59-24.89,83.03-67.09,34.44-42.2,20.31-59.54,54.76-101.76,34.45-42.22,48.59-24.89,83.04-67.11,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316-2",
    className: "cls-3",
    d: "m253.86,707.52c4.54-8.13,9.81-15.82,15.76-22.99,34.44-42.22,48.59-24.89,83.03-67.09,34.44-42.2,20.31-59.54,54.76-101.76,34.45-42.22,48.59-24.89,83.04-67.1,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317-2",
    className: "cls-3",
    d: "m270.88,707.52c33.53-40.28,47.75-23.88,81.77-65.57,34.45-42.22,20.31-59.54,54.76-101.76,34.45-42.22,48.59-24.89,83.04-67.1,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318-2",
    className: "cls-3",
    d: "m297.62,707.52c17.49-11.19,31.54-12.28,55.03-41.06,34.45-42.22,20.31-59.54,54.76-101.76,34.45-42.22,48.59-24.89,83.04-67.11,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2",
    className: "cls-3",
    d: "m337.08,707.52c5.62-5.1,10.82-10.64,15.57-16.56,34.45-42.22,20.31-59.54,54.76-101.76,34.45-42.22,48.59-24.89,83.04-67.1,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2",
    className: "cls-3",
    d: "m358.79,707.52c26.67-36.63,16.42-54.35,48.62-93.81,34.44-42.22,48.59-24.89,83.04-67.1,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2",
    className: "cls-3",
    d: "m373.08,707.52c9.91-22.3,10.16-39.68,34.33-69.3,34.44-42.22,48.59-24.89,83.04-67.1,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-2",
    className: "cls-3",
    d: "m382.14,707.52c4.58-12.97,10.39-26.54,25.27-44.79,34.44-42.22,48.59-24.89,83.04-67.11,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323-2",
    className: "cls-3",
    d: "m393.19,707.52c4.2-7.12,8.96-13.9,14.22-20.28,34.44-42.22,48.59-24.89,83.04-67.11,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324-2",
    className: "cls-3",
    d: "m410.96,707.52c31.91-36.85,46.25-22.15,79.49-62.88,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325-2",
    className: "cls-3",
    d: "m439.89,707.52c15.52-8.87,29.1-12.07,50.56-38.37,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326-2",
    className: "cls-3",
    d: "m477.79,707.52c4.5-4.36,8.73-8.99,12.66-13.86,20.54-25.17,23.8-41.49,30.39-59.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327-2",
    className: "cls-3",
    d: "m498.51,707.52c13.52-19.4,16.72-33.52,22.33-48.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2",
    className: "cls-3",
    d: "m512.05,707.52c3.52-8.42,5.81-16.21,8.79-24.36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.4acb7597aa7003dac4ac2808635602e6.svg";
export { ForwardRef as ReactComponent };